// DS — czasy ruchu odczytane z tokenów, dla komponentów, które muszą
// poczekać z odmontowaniem elementu do końca wyjścia (Dialog, Toast, BottomSheet).
//
// Jedyne źródło liczb to `tokens.css` (`--dur-fast` / `--dur` / `--dur-slow`);
// wartości niżej są WYŁĄCZNIE zapasem na środowisko bez CSS (jsdom), gdzie
// getComputedStyle zwraca pusty string. Przy `prefers-reduced-motion: reduce`
// wyjście trwa 0 ms — tokens.css skraca przejścia do 0.01 ms, więc czekanie
// byłoby czekaniem na nic.

type DurToken = '--dur-fast' | '--dur' | '--dur-slow' | '--dur-sheet-out'

const FALLBACK_MS: Record<DurToken, number> = { '--dur-fast': 140, '--dur': 220, '--dur-slow': 320, '--dur-sheet-out': 180 }

export function motionMs(token: DurToken): number {
  if (typeof window === 'undefined' || typeof document === 'undefined') return FALLBACK_MS[token]
  if (window.matchMedia?.('(prefers-reduced-motion: reduce)')?.matches) return 0
  const raw = getComputedStyle(document.documentElement).getPropertyValue(token).trim()
  // Pusty odczyt = arkusz tokenów nie jest załadowany (jsdom, test) = nie ma czego
  // animować: wyjście natychmiast. Zapas liczbowy tylko dla wartości nie do sparsowania.
  if (!raw) return 0
  const n = parseFloat(raw)
  if (Number.isNaN(n)) return FALLBACK_MS[token]
  return raw.endsWith('ms') ? n : n * 1000
}

/** Czas wyjścia warstwy (dialog, toast): `--dur-fast`. */
export const leaveMs = () => motionMs('--dur-fast')
/** Czas wyjazdu arkusza w dół (R6: 180 ms). Jedna anatomia = jeden czas dla każdego okna. */
export const sheetLeaveMs = () => motionMs('--dur-sheet-out')
